import { IAppointment } from '../../interfaces/appointment.interface';
import { AppointmentWizardSelections } from './appointment-wizard.models';

export class SetAppointmentWizardSummary {
  static type = '[AppointmentWizard] Set Summary';

  constructor(public summary: IAppointment) {}
}

export class ClearAppointmentWizardSummary {
  static type = '[AppointmentWizard] Clear Summary';
}

export class SetAppointmentWizardSelections {
  static type = '[AppointmentWizard] Set Selections';

  constructor(public selections: Partial<AppointmentWizardSelections>) {}
}
